import { render, staticRenderFns } from "./recordControlEdit.vue?vue&type=template&id=45e1910a&scoped=true&"
import script from "./recordControlEdit.vue?vue&type=script&lang=ts&"
export * from "./recordControlEdit.vue?vue&type=script&lang=ts&"
import style0 from "./recordControlEdit.vue?vue&type=style&index=0&id=45e1910a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e1910a",
  null
  
)

export default component.exports